import { AsyncPipe, NgIf } from '@angular/common'
import { Component, Input } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table'
import { NgxPaginationModule } from 'ngx-pagination'
import { Group } from '../../../models/group.interface'
import { catchError, map, Observable, switchMap, tap } from 'rxjs'
import { MatDialog } from '@angular/material/dialog'
import { GroupService } from '../../../services/group/group.service'
import { LoadingService } from '../../../services/loadingService/loading.service'
import { ActivatedRoute, Router } from '@angular/router'
import { LayoutService } from '../../../services/layout/layout.service'
import { Title } from '@angular/platform-browser'
import { PAGINATION } from '../../../shared/constants'
import { Filter, QueryGet } from '../../../shared/query-types'
import { GroupFormComponent } from '../group-form/group-form.component'
import { SearchComponent } from '../../../components/search/search.component'
import { PermisionDirective } from '../../../directives/permision.directive'
import { ToastrService } from 'ngx-toastr'

@Component({
    selector: 'app-group-list',
    standalone: true,
    imports: [
        SearchComponent,
        PermisionDirective,
        MatIcon,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        NgIf,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        AsyncPipe,
    ],
    templateUrl: './group-list.component.html',
    styleUrl: './group-list.component.css',
})
export class GroupListComponent {
    groups: Group[] = []
    public page = 1
    asyncGrupos!: Observable<Group[]>
    @Input() orden: string = ''
    limit = 10
    total = 0
    showColumns: string[] = ['acciones', 'nombre', 'Privilegios', 'permisos']

    constructor(
        private dialog: MatDialog,
        private groupService: GroupService,
        private layoutService: LayoutService,
        private loadingService: LoadingService,
        private router: Router,
        private toastr: ToastrService,
        private activatedRouter: ActivatedRoute,
        private title: Title
    ) {
        this.title.setTitle('Grupos')
    }

    ngOnInit(): void {
        this.layoutService.paginationLimit$
            .pipe(
                switchMap((limit) => {
                    this.limit = limit
                    return this.activatedRouter.queryParamMap
                }),
                switchMap((params) => {
                    const pageNum = params.get('page') || '1'
                    const search = params.get('search') || ''
                    this.page = parseInt(pageNum)
                    this.fetchGroups(PAGINATION.first_page, null, search)
                    return this.layoutService.paginationLimit$
                })
            )
            .subscribe()
    }

    fetchGroups(page: number, filter: Filter | null = null, search = '') {
        const offset = page > 1 ? page * this.limit - this.limit : 0
        const params: QueryGet = {
            order: '-id',
            limit: this.limit,
            offset,
            search,
            filters: [],
        }
        if (filter) {
            params.filters.push(filter)
        }
        this.page = page
        this.loadingService.show(true)
        this.asyncGrupos = this.groupService.getGroups(params).pipe(
            tap((data) => {
                this.groups = data.results
                this.groupService.setGrupo(data.results[0])
                this.groupService.setGrupos(data.results)
                this.total = data.count
            }),
            map((res) => {
                this.loadingService.show(false)
                return res.results
            }),
            catchError((error) => {
                this.loadingService.show(false)
                // this.sweetAlert.showAlertErrorGeneral();
                this.router.navigate(['inicio/'])
                return []
            })
        )
    }

    openForm(group: Group | null) {
        const dialogRef = this.dialog.open(GroupFormComponent, {
            width: '600px',
            height: 'auto',
            maxHeight: '80vh',
            data: { group: group },
        })

        dialogRef.afterClosed().subscribe(() => {
            this.fetchGroups(1)
        })
    }

    onRevokePermision(group: Group) {
        const confirmMsg = `Esta acción revocará todos los permisos al grupo ${group.name} ¿Estas seguro?`
        const isConfirmed = confirm(confirmMsg)
        if (!isConfirmed) return
        this.groupService.revokePermision(group).subscribe({
            next: () => {
                this.toastr.success(
                    `Se revocaron todos los permisos del grupo ${group.name}, correctamente!`,
                    'Exitoso!'
                )
                this.fetchGroups(1)
            },
            error: (err) => {
                this.toastr.error(
                    `No pudimos revocar los permisos del grupo ${group.name}.`,
                    'Error!'
                )
            },
        })
    }

    generatePermisions() {
        return this.groupService.generatePermisions()
    }
}
